var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.currentTab=='virtualExamine')?_c('virtual-examine'):(_vm.currentTab=='theoryExamine')?_c('theory-examine'):(_vm.currentTab=='allExamine')?_c('all-examine'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }